const GetSustainabilityReducer = (state = { type: 'LOADING_SUSTAINABILITY_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUSTAINABILITY_DETAIL_VIEW_ACTION':
            return action
        case 'RESET_SUSTAINABILITY_DETAIL_VIEW_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetSustainabilityFilterDetailsReducer = (state = { type: 'LOADING_SUSTAINABILITY_FILTER_DETAILS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUSTAINABILITY_FILTER_DETAILS_ACTION':
            return action
        default:
            return state
    }
}


const GetSustainabilityDropdownDetailsReducer = (state = { type: 'LOADING_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION':
            return action
        case 'RESET_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const FetchSustainabilitySupplierDetailsReducer = (state = { type: 'LOADING_SUSTAINABILITY_SUPPLIERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUSTAINABILITY_SUPPLIERS_ACTION':
            return action
        case 'RESET_SUSTAINABILITY_SUPPLIERS_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

export {
    GetSustainabilityReducer,
    GetSustainabilityFilterDetailsReducer,
    GetSustainabilityDropdownDetailsReducer,
    FetchSustainabilitySupplierDetailsReducer
}